module.exports = __webpack_public_path__ + "img/game-and-watch.3ca7ea30.png";